module.exports = __webpack_public_path__ + "static/mopz-extraimg3@2x-min-14c61ca00c3f6639398176f27f20f8f9.png";